import { Component, ContentChild, inject } from '@angular/core';
import { ViewConfig } from '@app/commons/utils/view-config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserListComponent } from '../../components/user-list/user-list.component';
import { CustomEventHandler } from '@app/commons/utils/event-handler';

@Component({
  selector: 'app-admin-management',
  templateUrl: './admin-management.component.html',
  styleUrl: './admin-management.component.scss',
  providers: [UserListComponent]
})
export class AdminManagementComponent {
  viewConfig = new ViewConfig();

  constructor(private eventHandler: CustomEventHandler) {
  }

  openCreateUser() {
    this.eventHandler.callEvent("open-create-user");
  }

  get isUserPage() {
    return window.location.href.includes('users');
  }
  get isChatbotDetailPage() {
    return window.location.href.includes('/admin/chatbot-management/');
  }
}
